module.exports = __webpack_public_path__ + "static/media/1.838d7bae.jpg";